import { createSignal } from "solid-js";

export interface ClientBranding {
    clientId: string;
    appName: string;
    app_bundle: string;
    // Developer website domain as listed on the app's store page — this is
    // where app-ads.txt is published and what SSPs verify inventory against,
    // so ad params must send this, not the domain hosting the WebView bundle.
    developerDomain: string;
    splashVideo: string;
    loginLogo: string;
    loginLogoWidth: number;
    loginLogoHeight: number;
    homeLogo: string;
    primaryColor: string;
    // Web page where the owner of an unregistered device signs up. When it is
    // set, the licence screen shows a QR code for it (with the device id
    // attached) next to the "Device Not Registered" card.
    registrationUrl?: string;
}

const CLIENTS: Record<string, ClientBranding> = {
    default: {
        clientId: "default",
        appName: "default",
           app_bundle: "com.solid.evomedia",
        developerDomain: "evomedia.pt",
        splashVideo: "/assets/splash_evomedia.mp4",
        loginLogo: "assets/evomedia_logo.png",
        loginLogoWidth: 349,
        loginLogoHeight: 114,
        homeLogo: "assets/evomedia_logo.png",
        primaryColor: "#1976D2",
        registrationUrl: "https://evomedia.pt/formulario.html",
    },
    innplay: {
        clientId: "innplay",
        appName: "InnPlay",
        app_bundle: "com.solid.innplay",
        developerDomain: "applay.cloud",
        splashVideo: "/assets/splash_innplay.mp4",
        loginLogo: "assets/innplay_logo.png",
        loginLogoWidth: 390,
        loginLogoHeight: 114,
        homeLogo: "assets/innplay_logo.png",
        primaryColor: "#D32F2F",
    },
    evomedia: {
        clientId: "evomedia",
        appName: "Evomedia",
        app_bundle: "com.solid.evomedia",
        developerDomain: "evomedia.pt",
        splashVideo: "/assets/splash_evomedia.mp4",
        loginLogo: "assets/evomedia_logo.png",
        loginLogoWidth: 349,
        loginLogoHeight: 114,
        homeLogo: "assets/evomedia_logo.png",
        primaryColor: "#1976D2",
        registrationUrl: "https://evomedia.pt/formulario.html",
    },
};

function readFromBridge(): string | null {
    try {
        const bridge = (window as any).AndroidBridge;
        const id = bridge?.getClientId?.();
        // Tells the three "undefined" causes apart: no bridge at all (browser /
        // not injected yet), bridge without the method (older APK), or the
        // method exists but returned something unexpected.
        console.log(
            "🔄 readFromBridge called, bridge clientId:", id,
            "| bridge:", typeof bridge,
            "| getClientId:", typeof bridge?.getClientId
        );
        if (id && CLIENTS[id]) return id;
    } catch (e) {
        // A Java exception inside getClientId (e.g. missing string resource)
        // surfaces here as a JS error rather than as undefined.
        console.warn("⚠️ readFromBridge failed:", e);
    }
    return null;
}

function resolveClientId(): string {
    const fromBridge = readFromBridge();
    if (fromBridge) {
        localStorage.setItem("applay_client", fromBridge);
        return fromBridge;
    }
    const stored = localStorage.getItem("applay_client");
    if (stored && CLIENTS[stored]) return stored;
    return "default";
}

export const [clientBranding, setClientBranding] =
    createSignal<ClientBranding>(CLIENTS[resolveClientId()] ?? CLIENTS.default);

/**
 * Call this in onMount of the first screen (SplashScreen).
 * The Android bridge is guaranteed to be available by then even if it
 * wasn't ready during module initialisation.
 */
export function refreshBranding(): void {
    const fromBridge = readFromBridge();
    console.log("🔄 refreshBranding called, bridge clientId: 1", fromBridge);
    if (!fromBridge) return;
    const branding = CLIENTS[fromBridge];
    console.log("🔄 refreshBranding called, bridge clientId:", fromBridge, branding);
    if (branding && branding.clientId !== clientBranding().clientId) {
        localStorage.setItem("applay_client", fromBridge);
        setClientBranding(branding);
    }
}
